const PartnerUserRolesEnum = Object.freeze({
  ADMIN: 'FNvP6fH9cY',
  USER: 'j6ueKSoXno',
  BUCHHALTUNG: 'AtMrh2ixka'
})
export default PartnerUserRolesEnum
